import { FC, useMemo, useState } from 'react';
import SectionLayout from 'atoms/components/SectionLayout';
import Dropdown from 'atoms/components/Dropdown';
import { useTranslation } from 'react-i18next';
import { SelectChangeEvent } from '@mui/material';
import { ReactComponent as ThreeDotsIcon } from 'atoms/icons/svg/threedots.svg';
import useMobile from 'hooks/useMobile';
import useDeviationList from 'components/Dashboard/Customer/Deviation/List/hooks/useDeviationList';
import { useParams } from 'react-router';
import SuspenseLoader from 'components/SuspenseLoader';
import DeviationListTable from 'components/Dashboard/Customer/Deviation/List/Table';
import ButtonV2 from 'atoms/components/Buttons/V2/ButtonV2';
import './Deviations.scss';

const Deviations: FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const { penNumber } = useParams();

  const { holes, isFetching, error } = useDeviationList({
    pen: penNumber,
  });

  const [showAll, setShowAll] = useState(false);

  const content = useMemo(() => {
    if (isFetching) {
      return <SuspenseLoader isFullScreen={false} />;
    }

    if (!holes.length) {
      return (
        <span className="no-holes">
          {t('We have not detected any deviations.')}
        </span>
      );
    }

    const visibleHoles = showAll ? holes : holes.slice(0, 3);

    return (
      <div className="holes-list">
        <DeviationListTable holes={visibleHoles} />

        {!showAll && holes.length > 3 && (
          <div className="actions">
            <ButtonV2 size="m" onClick={() => setShowAll(true)} type="tertiary">
              {t('Show more')}
            </ButtonV2>
          </div>
        )}
      </div>
    );
  }, [isFetching, error, holes, showAll]);

  return (
    <SectionLayout
      className="deviations-list"
      header={
        <>
          <span className="title">{t('Deviations')}</span>
          <div className="filters">
            <Dropdown
              size="small"
              value="alle-avvik"
              clickableNodeOverride={
                isMobile ? (
                  <ThreeDotsIcon className="mobile-threedot" />
                ) : undefined
              }
              options={[
                {
                  label: t('All deviation types'),
                  value: 'alle-avvik',
                },
              ]}
              isLoading={false}
              onChange={(e: SelectChangeEvent<unknown>) =>
                console.log(e.target.value as string)
              }
            />

            {!isMobile && (
              <Dropdown
                value="new-deviation"
                size="small"
                options={[
                  {
                    label: t('New deviations'),
                    value: 'new-deviation',
                  },
                ]}
                isLoading={false}
                onChange={(e: SelectChangeEvent<unknown>) =>
                  console.log(e.target.value as string)
                }
              />
            )}
          </div>
        </>
      }
    >
      {content}
    </SectionLayout>
  );
};

export default Deviations;
